import { render } from "./Installs.vue?vue&type=template&id=a84e27aa"
import script from "./Installs.vue?vue&type=script&lang=js"
export * from "./Installs.vue?vue&type=script&lang=js"

import exportComponent from "/home/desarollo2/Documents/GitHub/dicora-customers-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__